import { IconSvg, IconSvgProps } from "./icon"

export default function Stop(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeWidth={0}>
      <rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2" />
    </IconSvg>
  )
}
